export default "__VITE_ASSET__TK_QgRtu__"